
import ExamProxy from './ExamProxy';


export default class ExamReflect {
  constructor(data) {
    this.data = data;
    // 调用生产反射
    this.createReflect(this.data);
  }

  /**
   * 生成检查项属性代理反射
   */
  createReflect(data) {
    Object.entries(data).forEach(([key, val]) => {
      Object.defineProperty(this, key, {
        get() {
          if (val instanceof ExamProxy) {
            return this.data[key].value;
          }
          return this.data[key];
        },
        set(value) {
          this.data[key].value = value;
        },
      });
    });
  }
}
